module.exports = __webpack_public_path__ + "static/media/cancelShiftMove2.c5045388.svg";